// notificationService.js

import React, { useEffect, useState } from "react";
import ReactDOMServer from 'react-dom/server';
import Icon from "@Components/Icon";

/**
 * Displays a UIkit notification with the specified options.
 *
 * @param {Object} options - The notification options.
 * @param {string} options.message - The message to display.
 * @param {string} [options.status='primary'] - The status of the notification ('primary', 'success', 'warning', 'danger').
 * @param {string} [options.iconName] - The name of the icon to display.
 * @param {string} [options.iconColor] - The color of the icon.
 * @param {number} [options.timeout=0] - The duration of the notification in milliseconds (0 for persistent).
 * @param {string} [options.pos='bottom-right'] - The position of the notification.
 * @param {boolean} [options.bold=false] - Whether to apply bold styling to the message.
 */
export const showNotification = _ref => {
  let {
    message,
    status = 'primary',
    iconName,
    iconColor,
    timeout = 3000,
    pos = 'bottom-center',
    bold = false
  } = _ref;
  // Render the Icon component to static HTML if an iconName is provided
  const iconHTML = iconName ? ReactDOMServer.renderToStaticMarkup(/*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    color: iconColor
  })) : '';

  // Build the CSS classes for the message
  const messageClasses = "uk-text-small ".concat(bold ? 'uk-text-bold' : '', " uk-text-").concat(status, " uk-flex uk-flex-row uk-flex-middle");

  // Construct the notification message
  const notificationMessage = "<div class=\"".concat(messageClasses, "\">").concat(iconHTML, "<span class=\"uk-margin-small-left uk-width-4-5\">").concat(message, "</span></div>");

  // Display the notification using UIkit
  UIkit.notification({
    message: notificationMessage,
    status,
    pos,
    timeout
  });
};